import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { TIMELINE } from "../../lib/portfolioData";
import { SectionHeader, Reveal } from "./Reveal";

export const Timeline = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start center", "end center"],
  });
  const lineScale = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section id="experience" data-testid="experience-section" className="relative py-24 sm:py-28 md:py-44 bg-[#0a1220]/40 border-y border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeader chapter="05" overline="Media Footprint" title="Leadership across India's premier media houses." />

        <div ref={ref} className="relative pl-7 sm:pl-8 md:pl-0">
          {/* Track */}
          <div className="absolute left-[6px] sm:left-[7px] md:left-1/2 top-2 bottom-2 w-px bg-white/10 md:-translate-x-1/2" />
          <motion.div
            style={{ scaleY: lineScale }}
            className="absolute left-[6px] sm:left-[7px] md:left-1/2 top-2 bottom-2 w-px bg-accent origin-top md:-translate-x-1/2"
          />

          <div className="space-y-10 sm:space-y-14 md:space-y-0">
            {TIMELINE.map((item, i) => {
              const left = i % 2 === 0;
              return (
                <div
                  key={item.company}
                  className={`relative md:grid md:grid-cols-2 md:gap-16 md:py-10 ${left ? "" : "md:text-left"}`}
                >
                  {/* Node */}
                  <span className="absolute left-[-24px] sm:left-[-25px] md:left-1/2 top-7 md:top-12 md:-translate-x-1/2 z-10">
                    <span className={`block w-3.5 h-3.5 rounded-full border-2 ${item.current ? "bg-accent border-accent" : "bg-[#050b14] border-white/30"}`}>
                      {item.current && <span className="absolute inset-0 rounded-full bg-accent animate-ping opacity-60" />}
                    </span>
                  </span>

                  <Reveal
                    className={left ? "md:col-start-1 md:text-right md:pr-4" : "md:col-start-2 md:pl-4"}
                  >
                    <div data-testid={`timeline-${i}`} className="rounded-2xl border border-white/10 bg-[#050b14]/60 p-5 sm:p-6 md:p-8 hover:border-accent/40 transition-colors">
                      <div className={`flex flex-wrap items-center gap-2 sm:gap-3 mb-3 ${left ? "md:justify-end" : ""}`}>
                        <span className="text-xs font-medium text-accent tracking-wider">{item.period}</span>
                        {item.current && (
                          <span className="text-[0.6rem] uppercase tracking-widest px-2 py-0.5 rounded-full bg-accent/15 text-accent">Now</span>
                        )}
                      </div>
                      <h3 className="font-display text-xl sm:text-2xl md:text-3xl tracking-tight leading-snug">{item.company}</h3>
                      <p className="text-sm text-white/70 mt-1 mb-4">{item.role}</p>
                      <p className="text-sm text-[#94a3b8] leading-relaxed">{item.desc}</p>
                    </div>
                  </Reveal>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
